// #region IMPORTS
import { createSlice } from '@reduxjs/toolkit';
// #endregion

// #region CONSTANTS
const initialState = {
  studies: {
    studies: [],
  },
};
// #endregion

export const studiesSlice = createSlice({
  initialState,
  name: 'studies',
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setStudies(state, action) {
      state.studies = action.payload;
    },
  },
});

// #region ACTIONS
export const { setStudies } = studiesSlice.actions;
// #endregion

// #region SELECTORS
export const selectStudies = state => {
  return state.studies.studies;
};

// #endregion

export default studiesSlice.reducer;
